import React, { useEffect, useState } from "react";
import * as OFMSUI from "react-bootstrap";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HousingService from "../../../Services/HousingService";
import Swal from "sweetalert2";
import ShowAlert from "../../alert";

const Distwisebudgetlimit = () => {
    const history = useHistory();
    const [hoveredHeader, setHoveredHeader] = useState(null);
    const [details, setDetails] = useState([]);
    const [details1, setDetails1] = useState([]);
    const [distTotal, setDistTotal] = useState([]);
    const [editableRows, setEditableRows] = useState([]);
    const [Item, setItem] = useState([]);
    const [Item1, setItem1] = useState([]);

    const data = {
        Regular: ["20101-SALARIES TO STAFF", "20102-SALARIES TO MD", "20104-MEDICAL ALLOWANCE", "20106-CONVEYANCE ALLOWANCE", "20107-EX-GRATIA", "20108-WAGES TO NMR",
            "20110-HONORARIUM TO CHAIRMAN AND DIRECTOR", "20111-ALLOWANCE TO CHAIRMAN", "20112-REMUNERATION TO OUTSOURCING STAFF", "20113-ADM COST OF OUTSOURCING STAFF",
            "20501-EDUCATIONAL ALLOWANCE", "20502-LEAVE SALARY CONTRIBUTION", "20503-PENSION FUND CONTRIBUTION", "20504-AWARDS & INCENTIVES", "20508-LIVERY TO STAFF",
            "20623-SECURITY CHARGES", "20644-STAFF ADVANCE & INTEREST WAIVED", "21301-EMPLOYER EPF CONTRIBUTION", "21303-ADMN. CHARGES ON EPF/FPF", "21304-EDLIS CHARGES", "21305-ADMN. CHARGES ON EDLIS"
        ],
        Conveyance: [
            "20605-INSURANCE - VEHICLES",
            "20620-HIRE CHARGES - VEHICLES",
            "20634-POL CHARGES",
            "20635-REPAIRS & MAINTENANCE - VEHICLES",
        ],
        AdminExp: [
            "20105-MEDICAL EXPENSES- M.D.",
            "20109-MEDICAL EXPENSES-STAFF(SPL)",
            "20203-GODOWN RENT",
            "20204-TRANSPORTATION CHARGES", "20401-GRATUITY", "20505-LTC TO STAFF", "20506-LTC - M.D.", "20601-RENT", " 20602-RATES & TAXES", "20603-WATER CHARGES", "20606-ELECTRICITY CHARGES",
            "20607-PRINTING & STATIONERY", "20608-POSTAGE", "20609-TELEGRAMS", "20610-TELEPHONES", "20611-INTERNET CHARGES", "20612-TRAVELLING EXPENSES - STAFF", "20613-TRAVELLING EXPENSES - M.D",
            "20615-ADVERTISEMENT CHARGES", "20618-LEGAL CHARGES", "20619-REGISTRATION & FILLING CHARGES", "20621-RECRUITMENT & TRAINING COST", "20626-EDP CHARGES & EXPENSES", " 20627-DIRECTORS SITTING FEES",
            " 20628-MEETINGS & CONFERENCES", "20630-CEMENT TESTING CHARGES", " 20631-MISC. CONSTRUCTION EXPENSES", " 20632-BOOKS & PEROIDICALS", "20633-ACCOUNTING CHARGES", "20636-REPAIRS & MAINTAINANCE - OTHERS",
            "20638-HIRE CHARGES - OTHERS", " 20640-HARDWARE DEVELOPMENT CHARGES", "20642-AUDIT FEE", " 20643-REPAIRS & MAINTAINANCE - BUILDING", "31802-TRAVELLING EXPENSES PAYABLE"
            , ""],
        Others: [
            "20206-INSTITUTIONAL CHARGES-ZMS",
            "20207-INSTITUTIONAL CHARGES - VOs/SHGs",
            "20208-SERVICE CHARGES TO SERVICE PROVIDERS", " 20599-OTHER CONTRIBUTION", "20622-DONATIONS", "20637-PROFESSIONAL CHARGES", "20639-SOFTWARE DEVELOPMENT CHARES", " 20645-INAUGURAL EXPENSES",
            "20646-COLOURING EXPENSES", "20699-MISCELLANEOUS EXPENDITURE",
        ],
        CapitalExp: [
            "40101-LAND",
            "40102-BUILDINGS",
            "40103-PLANT & MACHINERY",
            "40104-OFFICE & OTHER EQUIPMENT", "40105-FURNITURE & FIXTURES", "40106-ELECTRICAL EQUIPMENT", "40107-VEHICLES", "40109-BICYCLES", "40110-COMPUTERS"
        ],
        AdvancetoStaff: [
            "41001-FESTIVAL ADVANCE",
            "41002-EDUCATIONAL ADVANCE",
            "41003-CYCLE ADVANCE",
            "41004-MOTOR CAR/ CYCLE ADVANCE", "41005-HOUSE BUILDING ADVANCE", "41006-TOUR ADVANCE", "41007-L.T.C.ADVANCE", "41008-SALARY ADVANCE", "41009-MISC. STAFF ADVANCE", "41010-SPECIAL FESTIVAL ADVANCE",
            "41011-MARRIAGE ADVANCE", "41013-MEDICAL ADVANCE", "41014-PERSONAL COMPUTER ADVANCE"
        ],
    };

    useEffect(() => {
        HousingService.getGmfBudgetLimitsDistricts().then((res) => {
            if (res.data) {
                setDetails(res.data);
                const filterData=res.data.filter((item)=>item.securityid !='00');
                setDistTotal(filterData);
            }
        })

        
        // HousingService.getGmfBudgetLimitsHod().then((res) => {
        //     if (res.data) {
        //         setDistTotal(res.data);
        //     }
        // })
    }, []);

    const handleCheckboxClick = (e, index, item, type) => {
        setItem(item)
        const isChecked = e.target.checked;
        if (type === "1") {
            setEditableRows((prev) => {
                const newEditableRows = [...prev];
                newEditableRows[index] = isChecked;
                if (!isChecked) {
                    handleFieldChange("details", index, "regularpresentallocation", Item.regularpresentallocation);
                    handleFieldChange("details", index, "conveyancepresentallocation", Item.conveyancepresentallocation);
                    handleFieldChange("details", index, "admnexppresentallocation", Item.admnexppresentallocation);
                    handleFieldChange("details", index, "otherspresentallocation", Item.otherspresentallocation);
                    handleFieldChange("details", index, "capitalexppresentallocation", Item.capitalexppresentallocation);
                    handleFieldChange("details", index, "advancetostaffpresentallocation", Item.advancetostaffpresentallocation);
                }
                return newEditableRows;
            });
        }
        // else {
        //     setItem1(item)
        //     setEditableRows((prev) => {
        //         const newEditableRows = [...prev];
        //         newEditableRows[index] = isChecked;
        //         if (!isChecked) {
        //             handleFieldChange("details1", index, "regularpresentallocation", Item1.regularpresentallocation);
        //             handleFieldChange("details1", index, "conveyancepresentallocation", Item1.conveyancepresentallocation);
        //             handleFieldChange("details1", index, "admnexppresentallocation", Item1.admnexppresentallocation);
        //             handleFieldChange("details1", index, "otherspresentallocation", Item1.otherspresentallocation);
        //             handleFieldChange("details1", index, "capitalexppresentallocation", Item1.capitalexppresentallocation);
        //             handleFieldChange("details1", index, "advancetostaffpresentallocation", Item1.advancetostaffpresentallocation);
        //         }
        //         return newEditableRows;
        //     });
        // }
    };

    const handleFieldChange = (arrayName, index, field, value) => {
        console.log("editableRows[index]", editableRows[index])
        if (arrayName === "details") {
            setDetails((prevDetails) => {
                const updatedDetails = [...prevDetails];
                updatedDetails[index] = { ...updatedDetails[index], [field]: value };
                return updatedDetails;
            });
        } else if (arrayName === "details1") {
            setDetails1((prevDetails1) => {
                const updatedDetails1 = [...prevDetails1];
                updatedDetails1[index] = { ...updatedDetails1[index], [field]: value };
                return updatedDetails1;
            });
        }
    };

    const Update = async () => {
        const isAnyRowSelected = editableRows.some((isSelected) => isSelected);
        if (!isAnyRowSelected) {
            ShowAlert("Please select at least one checkbox before updating", "warning");
            return;
        }
        const updatedBudgetData = details
            .map((item, index) => ({
                code: item.code,
                regularAlloc: item.regularpresentallocation,
                conveyanceAlloc: item.conveyancepresentallocation,
                adminExpAlloc: item.admnexppresentallocation,
                othersAlloc: item.otherspresentallocation,
                capitalExpAlloc: item.capitalexppresentallocation,
                advanceStaffAlloc: item.advancetostaffpresentallocation
            }))
            .filter((_, index) => editableRows[index]);
        const updatedBudgetData1 = details1
            .map((item, index) => ({
                code: item.code,
                regularAlloc: item.regularpresentallocation,
                conveyanceAlloc: item.conveyancepresentallocation,
                adminExpAlloc: item.admnexppresentallocation,
                othersAlloc: item.otherspresentallocation,
                capitalExpAlloc: item.capitalexppresentallocation,
                advanceStaffAlloc: item.advancetostaffpresentallocation
            }))
            .filter((_, index) => editableRows[index + details.length]);
        const combinedBudgetData = [...updatedBudgetData, ...updatedBudgetData1];
        Swal.fire({
            text: "Are You Sure Want to Update?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const responseBudget = await HousingService.updatePresentGmfBudgetLimits(
                    combinedBudgetData
                );
                if (responseBudget?.data[0]?.responseToken === 1) {
                    ShowAlert(responseBudget?.data[0]?.responseMsg, "success").then(() =>
                        window.location.reload()
                    );
                } else {
                    ShowAlert(responseBudget?.data[0]?.responseMsg, "error");
                }
            }
        });
    };

    const allowNumbersOnly = (e) => {
        const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete"];
        if (
            !/^[0-9.]$/.test(e.key) &&
            !allowedKeys.includes(e.key)
        ) {
            e.preventDefault();
        }
        if (e.key === "." && e.target.value.includes(".")) {
            e.preventDefault();
        }
    };

    return (
        <div>
            <NavigationServicesHeader />
            <OFMSUI.Container fluid style={{ width: "90%" }}>
                <OFMSUI.Row>
                    <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        xxl={6}
                        className="page-titlespacing"
                    >
                        <div className="inner-herbpage-service-title1">
                            <h1 style={{ marginLeft: "-15px" }}>
                                District Wise Budget Limit
                            </h1>
                        </div>
                    </OFMSUI.Col>

                    <OFMSUI.Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        xxl={6}
                        className="page-titlespacing"
                    >
                        <button
                            className="btn btn-primary btn-sm"
                            style={{ float: "right", marginLeft: "3px", backgroundColor: "#474a49", borderColor: "#474a49", color: "#fff" }}
                            onClick={() => history.goBack()}
                        >
                            Back
                        </button>
                    </OFMSUI.Col>
                </OFMSUI.Row>
            </OFMSUI.Container>
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <OFMSUI.Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                        <tr>
                            <td colSpan={16} style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                Statement Showing the District-wise Budget Limits/Bench Mark for Expenditure for the Month of{" "}
                                {new Date().toLocaleString("default", { month: "long", year: "numeric" })} (Rs. in lakhs)
                            </td>
                        </tr>

                        <tr className="table_countshead">
                            <th rowSpan={2}>S No.</th>
                            <th rowSpan={2}> District Name</th>
                            {Object.keys(data).map((header) => (
                                <th
                                    key={header}
                                    colSpan={2}
                                    onMouseEnter={() => setHoveredHeader(header)}
                                    onMouseLeave={() => setHoveredHeader(null)}
                                    style={{
                                        position: "relative",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {header}
                                    {hoveredHeader === header && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                backgroundColor: "#FAF3E0",
                                                color: "#4E342E",
                                                borderRadius: "10px",
                                                padding: "5px 8px",
                                                fontSize: "12px",
                                                zIndex: 10,
                                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {data[header].map((item, index) => (
                                                <p key={index} style={{ marginBottom: "5px" }}>
                                                    {item}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </th>
                            ))}

                            <th rowSpan={2}>total</th>
                            <th rowSpan={2}> Check For Edit</th>
                        </tr>
                        <tr className="table_countshead">
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                            <th> Original Allocation</th>
                            <th> Present Allocation</th>
                        </tr>
                    </thead>
                    <tbody>

                        {details.map((item, index) => (
                            <>
                                {/* Insert District Total Row Above the 14th Record */}
                                {index === 13 && (
                                    <tr key="district-total">
                                        <td colSpan={2} style={{ fontWeight: "bold", textAlign: "center" }}>
                                            District Total
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.regularoriginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.regularpresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.conveyanceoriginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.conveyancepresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.admnexporiginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.admnexppresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.othersoriginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.otherspresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.capitalexporiginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.capitalexppresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.advancetostafforiginalallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.advancetostaffpresentallocation || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td >
                                            {distTotal.reduce(
                                                (total, item) => total + parseFloat(item.total || 0),
                                                0
                                            ).toFixed(2)}
                                        </td>
                                        <td></td>
                                    </tr>
                                )}
                                {/* Render Individual Row */}
                                <tr key={`details-${index}`}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td >{item.regularoriginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.regularpresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "regularpresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.regularpresentallocation > item.regularoriginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.regularpresentallocation > item.regularoriginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.regularpresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.conveyanceoriginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.conveyancepresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "conveyancepresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.conveyancepresentallocation > item.conveyanceoriginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.conveyancepresentallocation > item.conveyanceoriginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.conveyancepresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.admnexporiginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.admnexppresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "admnexppresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.admnexppresentallocation > item.admnexporiginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.admnexppresentallocation > item.admnexporiginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.admnexppresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.othersoriginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.otherspresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "otherspresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.otherspresentallocation > item.othersoriginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.otherspresentallocation > item.othersoriginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.otherspresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.capitalexporiginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.capitalexppresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "capitalexppresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.capitalexppresentallocation > item.capitalexporiginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.capitalexppresentallocation > item.capitalexporiginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.capitalexppresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.advancetostafforiginalallocation}</td>
                                    <td >
                                        {editableRows[index] ? (
                                            <input
                                                type="text"
                                                value={item.advancetostaffpresentallocation}
                                                maxLength={6}
                                                onChange={(e) =>
                                                    handleFieldChange("details", index, "advancetostaffpresentallocation", e.target.value)
                                                }
                                                onKeyPress={(e) => allowNumbersOnly(e)}
                                                style={{
                                                    width: "80px",
                                                    padding: "2px",
                                                    color: item.advancetostaffpresentallocation > item.advancetostafforiginalallocation ? "red" : "black",
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    color: item.advancetostaffpresentallocation > item.advancetostafforiginalallocation ? "red" : "black",
                                                }}
                                            >
                                                {item.advancetostaffpresentallocation}
                                            </span>
                                        )}
                                    </td>
                                    <td >{item.total}</td>
                                    <td style={{ textAlign: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={editableRows[index] || false}
                                            onChange={(e) => handleCheckboxClick(e, index, item, "1")}
                                        />
                                    </td>
                                </tr>
                            </>
                        ))}
                        <tr>
                            <td colSpan={2} style={{ fontWeight: "bold", textAlign: "center" }}>
                                Total
                            </td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.regularoriginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.regularpresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.conveyanceoriginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.conveyancepresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.admnexporiginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.admnexppresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.othersoriginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.otherspresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.capitalexporiginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.capitalexppresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.advancetostafforiginalallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.advancetostaffpresentallocation || 0), 0).toFixed(2)}</td>
                            <td >{details.reduce((total, item) => total + parseFloat(item.total || 0), 0).toFixed(2)}</td>
                            <td></td>
                        </tr>

                    </tbody>

                </OFMSUI.Table>
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-success btn-sm" onClick={() => Update()} >
                        Update
                    </button>
                </div>
            </OFMSUI.Container>
        </div>
    );
};
export default Distwisebudgetlimit;

